import { PlayerAhoyEvent } from '../player_ahoy_event';
import { PlayerEnvironment } from '../player_environment';

export default class SqueezeFrame {
  static shouldStart({ data } = {}) {
    return !!data.squeezeFrameFirstRenderTime() > 0
  }

  constructor(options = {}) {
    this._tech = options.tech;
    this._data = options.data;
    this.adState = options.adState
  }

  tech() {
    return this._tech;
  }
 
  data() {
    return this._data;
  }

  firstRenderTime() {
    return this.data().squeezeFrameFirstRenderTime() * 1000;
  }

  start() {
    if (this.shouldTriggerSqueezeFrameAd()) {
      this.adState.tryUpdateShownAd('squeeze_frame', this.show.bind(this), this.hide.bind(this))
    }
  }

  show() {
    this.setWidescreenClassName();
    this.squeezePlayer();
    window.googletag.cmd.push(this.displayAd());

    this._selfHideTimeout = setTimeout(() => {
      this.hide();
    }, 10000);
  }

  shouldTriggerSqueezeFrameAd() {
    return !!(
      this.isGPTConfigured() && 
      this.isPlayerNotInPIPMode() && 
      this.isNotMobilePortraitScreen() && 
      this.isNotMobileLandscapeNonFullscreen());
  }

  isPlayerNotInPIPMode() {
    const player = document.querySelector('#article-player');

    if (player == null) {
      return true;
    }

    return !player.classList.contains('video-pip');
  }

  isGPTConfigured() {
    return !!(
      window.googletag &&
      window.googletag.apiReady &&
      window.googletag.pubadsReady &&
      window.kmklabs &&
      window.kmklabs.gpt &&
      window.kmklabs.gpt.squeeze_frame
    );
  }

  displayAd() {
    return function() {
      window.googletag.display(window.kmklabs.gpt.squeeze_frame);
    };
  }

  hide() {
    this.adState.tryResetShownAd('squeeze_frame')

    clearTimeout(this._selfHideTimeout);

    this.restorePlayer();
  }

  restorePlayer() {
    const playerComponentWrapper = document.getElementById('player_component_wrapper');
    const squeezeFrameAdContainer = document.getElementById('squeezeFrameAdContainer');
    playerComponentWrapper.classList.remove('squeeze');

    if (this.isMobileLandscapeFullscreen()) {
      squeezeFrameAdContainer.style.display = 'none';
    }

    setTimeout(() => {
      this.tech().el().el().append(...playerComponentWrapper.childNodes);
      playerComponentWrapper.remove();
      squeezeFrameAdContainer.remove();
    }, 1500);
  }

  squeezePlayer() {
    const playerComponentWrapper = document.createElement('div');
    playerComponentWrapper.id = 'player_component_wrapper';
    playerComponentWrapper.className = 'player-component-wrapper';
    playerComponentWrapper.append(...this.tech().el().el().childNodes);

    this.tech().el().el().append(playerComponentWrapper);
    this.tech().el().el().append(this.createSqueezeFrameAdContainer());

    window.googletag.pubads().addEventListener('slotOnload', (event) => {
      if(!event.isEmpty && event.slot.getSlotId().getDomId() == 'squeeze_frame') {
        playerComponentWrapper.classList.add('squeeze');
      }
    });
  }

  isNotMobilePortraitScreen() {
    return !(PlayerEnvironment.isMobileSite() && !this.isScreenOnLandscape());
  }

  isNotMobileLandscapeNonFullscreen() {
    return !(PlayerEnvironment.isMobileSite() && this.isScreenOnLandscape() && !this.tech().isFullscreen());
  }

  isMobileLandscapeFullscreen() {
    return PlayerEnvironment.isMobileSite() && this.isScreenOnLandscape() && this.tech().isFullscreen();
  }

  isScreenOnLandscape() {
    return screen.height < screen.width;
  }

  createSqueezeFrameAdContainer() {
    const container = document.createElement('div');
    container.id = 'squeezeFrameAdContainer'
    container.className = 'squeeze-frame-ad-container';

    container.appendChild(this.createSqueezeFrameAd());

    return container;
  }

  createSqueezeFrameAd() {
    const squeezeFrameAd = document.createElement('div');
    squeezeFrameAd.id = 'squeeze_frame';

    return squeezeFrameAd;
  }

  sendStartEvent(event) {
    this.sendEvent("START", event);
  }

  sendEmptyEvent(event) {
    this.sendEvent("EMPTY", event);
  }

  sendImpressionEvent(event) {
    this.sendEvent("IMPRESSION_VIEWABLE", event);
  }

  sendEvent(ad_event, props = {}) {
    PlayerAhoyEvent.sendPlaybackBannerAd({
      ad_uuid: props.ad_uuid,
      ad_slot: 'squeeze_frame',
      play_uuid: this.data().playUUID(),
      ad_event: ad_event,
      advertiser_id: props.advertiser_id,
      campaign_id: props.campaign_id,
      creative_id: props.creative_id,
      is_empty: props.is_empty,
      line_item_id: props.line_item_id,
      size: props.size,
      source_agnostic_creative_id: props.source_agnostic_creative_id,
      source_agnostic_line_item_id: props.source_agnostic_line_item_id
   });
  }

  setWidescreenClassName() {
    const ratio = screen.width / screen.height;
    if (ratio >= 1.6) {
      const vjsContainer = document.querySelector('.video-js');
      vjsContainer.classList.add('widescreen');
    }
  }
}
